module.exports = __webpack_public_path__ + "static/media/carbody-4.96172446.png";